import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import theme from './OverlayDialog.scss';

class OverlayDialog extends React.Component {
    componentDidMount() {
        if (this.props.active) {
            document.body.addEventListener('keydown', this.handleEscKey);
            document.body.style.overflow = 'hidden';
            this.escKeyListener = true;
        }
    }

    UNSAFE_componentWillUpdate() {
        if (!this.props.active) document.body.style.overflow = 'hidden';
        if (this.props.active) document.body.style.overflow = null;
    }

    componentDidUpdate() {
        if (this.props.active && !this.escKeyListener) {
            document.body.addEventListener('keydown', this.handleEscKey);
            this.escKeyListener = true;
        }
    }

    componentWillUnmount() {
        if (this.escKeyListener && document.body) {
            document.body.removeEventListener('keydown', this.handleEscKey);
            this.escKeyListener = null;
        }
    }

    handleEscKey = e => {
        if (this.props.active && this.props.onEscapeClick && e.which === 27) {
            this.props.onEscapeClick(e);
        }
    };

    internalContainerRefCallback = ref => {
        const { getOverlayInternalDivRef } = this.props;
        this.internalDivRef = ref;
        getOverlayInternalDivRef && getOverlayInternalDivRef(ref);
    };

    render() {
        const {
            theme,
            children,
            active,
            dialogClassName,
            className,
            testId
        } = this.props;
        var overlayClass = classnames(theme.overlay, className, {
            [theme.active]: active
        });
        var dialogClasses = classnames(theme.dialog, dialogClassName);
        return active ? (
            <div data-test-id={testId} className={overlayClass}>
                <div
                    ref={this.internalContainerRefCallback}
                    className={dialogClasses}
                >
                    {children}
                </div>
            </div>
        ) : null;
    }
}

const ThemedOverlayDialog = themr('OverlayDialog', theme, { withRef: true })(
    OverlayDialog
);
export default ThemedOverlayDialog;
